import * as React from "react";

const ProTools = () => {
  const formRef = React.useRef();
  const [preserveGalleryIds, setPreserveGalleryIds] = React.useState(true);

  return (
    <div
      className="vm-grid vm-grid-cols-2 vm-my-10"
      style={{ gridTemplateColumns: `200px 1fr` }}
    >
      <label className="vm-font-semibold">Export Galleries</label>

      <div className="vm-mb-10">
        <label className="vm-flex vm-items-center vm-mb-5">
          <input
            type="checkbox"
            checked={preserveGalleryIds}
            onChange={(e) => setPreserveGalleryIds(e.target.checked)}
          />
          <div>Preserve Gallery IDs</div>
        </label>

        <a
          className="vm-bg-blue-500 vm-text-white vm-px-3 vm-py-2 vm-rounded hover:vm-bg-blue-600 hover:vm-text-white vm-no-underline
          "
          href={`${(window as any).vimeographyExportGalleriesUrl}${
            preserveGalleryIds ? "&preserve_gallery_ids=1" : ""
          }`}
          title="Export Vimeography Galleries"
        >
          Export galleries
        </a>
      </div>

      <label className="vm-font-semibold">Import Galleries</label>
      <div>
        <form
          ref={formRef}
          method="post"
          action={(window as any).vimeographyImportGalleriesUrl}
          encType="multipart/form-data"
        >
          <input
            type="file"
            name="vimeography_gallery_manifest"
            onChange={() => formRef.current.submit()}
          />
        </form>
      </div>
    </div>
  );
};

export default ProTools;
